import {QueryAdapter} from "./query-adapter";
import * as GqlBuilder from "gql-query-builder";
import VariableOptions from "gql-query-builder/build/VariableOptions";
import {QueryBuilderOptions} from "./query-builder-options";

export type QueryOptionsBuilderArguments = {
  params: string
  variables: VariableOptions
  fields: Array<any>
  operationName: string
}

export type QueryOptions = {
  query: string
  variables: any
}

export class QueryBuilder {

  static buildQueryOptions(args: QueryOptionsBuilderArguments): QueryOptions {
    const queryOptions: QueryBuilderOptions = {
      operation: `root_search`,
      operationParameter: args.params,
      fields: [
        'total',
        {
          hits: [
            'type: typename',
            'index',
            {
              root: [
                ...args.fields
              ]
            }
          ]
        },
        'aggregations'
      ],
      variables: args.variables
    };
    return GqlBuilder.query(queryOptions, QueryAdapter, {operationName: args.operationName});
  }

}
